import React from 'react';
import { MobileHeader } from '../layouts/MobileHeader';

interface HeaderProps {
  toggleSider: () => void;
  isSiderOpened: boolean;
  isTwoColumnsLayout: boolean;
}

/**
 * Only mounted below the tablet breakpoint (see MainLayout) -- from tablet up
 * there is no header at all, so the desktop variant has been removed.
 */
export const Header: React.FC<HeaderProps> = ({ toggleSider, isSiderOpened }) => (
  <MobileHeader toggleSider={toggleSider} isSiderOpened={isSiderOpened} />
);
